import { useApiQuery, useApiMutation } from '@hook/common/useApi';
import { EBILLING_QUERY_KEY } from '@constant/billing/query-key';
import { getMySubscriptionApi, syncMySubscriptionApi } from '@api/billing/api-function';
import { ISubscriptionData, EApiSubscriptionStatus } from '@datatype/billing/api-type';
import { useTypedSelector } from '@hook/common/useStore';
import { LOCAL_STORAGE_USER_KEY } from '@config/auth';
import { queryClient } from '@config/query-client';
import { IApiResponse } from '@datatype/common/api-type';

// 나의 구독 조회
// - 인증된 사용자만 호출 (enabled 가드)
// - userKey를 queryKey에 포함해 사용자 전환 시 캐시 격리
export const useMySubscriptionQuery = () => {
  const isAuthenticated = useTypedSelector((state) => state.rootReducer.userReducer.isAuthenticated);
  const userKey = localStorage.getItem(LOCAL_STORAGE_USER_KEY) ?? '';
  return useApiQuery([EBILLING_QUERY_KEY.MY_SUBSCRIPTION, userKey], getMySubscriptionApi, undefined, {
    enabled: !!isAuthenticated && !!userKey,
  });
};

// 나의 구독 동기화 (POST)
// - 응답으로 받은 구독 데이터를 useMySubscriptionQuery 캐시에 직접 주입
// - RN 자동 리스너가 짧은 시간 내 여러 번 발화하는 경우가 있어 동일 mutationKey 진행 중이면 글로벌 dedup으로 차단
export const useSyncMySubscriptionMutation = () => {
  return useApiMutation<IApiResponse<ISubscriptionData | null>, EApiSubscriptionStatus>(
    syncMySubscriptionApi,
    {
      mutationKey: ['sync-my-subscription'],
      onSuccess: (response) => {
        const userKey = localStorage.getItem(LOCAL_STORAGE_USER_KEY) ?? '';
        queryClient.setQueryData<IApiResponse<ISubscriptionData | null>>(
          [EBILLING_QUERY_KEY.MY_SUBSCRIPTION, userKey],
          response,
        );
      },
    },
    { dedupInFlight: true },
  );
};
